import { __assign } from "tslib";
/* I13D in DS */
import React from 'react';
import IconWrap from '../../IconWrap';
var ArrowDown = function (props) {
    return (React.createElement(IconWrap, __assign({}, props),
        React.createElement("svg", { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.16399 6.17415L7.11373 11.1239C7.50426 11.5144 8.13742 11.5144 8.52795 11.1239L13.4777 6.17415C13.8682 5.78362 13.8682 5.15046 13.4777 4.75993C13.0872 4.36941 12.454 4.36941 12.0635 4.75993L7.82009 9.00204L3.5782 4.75993C3.18768 4.36941 2.55451 4.36941 2.16399 4.75993C1.77346 5.15046 1.77346 5.78362 2.16399 6.17415Z" }))));
};
ArrowDown.displayName = 'ArrowDown';
export default ArrowDown;
//# sourceMappingURL=ArrowDown.js.map